module.exports = __webpack_public_path__ + "img/Group 3.4d9ff494.png";